import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const getActiveProfileId = () => {
  try { return JSON.parse(sessionStorage.getItem('activeProfile'))?.id || ''; } catch { return ''; }
};
